import React, { createContext, useContext } from 'react';
import { INotification } from '../components/UI/Notifications/NotificationToast';
import { useNotifications } from '../hooks';

export type TNotificationsContext = {
  notifications: INotification[];
  addNotification: (notification: INotification) => void;
  removeNotification: (id: number) => void;
};

export const NotificationsContext = createContext<TNotificationsContext | null>(null);

export const NotificationsContextProvider = ({ children }: { children: React.ReactNode }) => {
  const value = useNotifications();

  return <NotificationsContext.Provider value={value}>{children}</NotificationsContext.Provider>;
};

export const useNotificationsContext = (): TNotificationsContext => {
  const context = useContext(NotificationsContext);

  if (!context) {
    throw new Error('useNotificationsContext must be used within a NotificationsContextProvider');
  }

  return context;
};
